import React, { useState, useEffect } from 'react';
import { Cards, Container, Grid, Header, Link, Modal, SpaceBetween, StatusIndicator } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import { useGlobalState } from '../../../context/GlobalStateContext';
import Icon from "@cloudscape-design/components/icon";
import { useStoreAdmin } from '../../../context/useStoreAdmin';

const pageSize = 20;

export const ConfigSectorsPage = () => {
  const storeAdmin = useStoreAdmin();
  const { setLoading } = useGlobalState();
  const { idPropiedad, setIdPropiedad } = useGlobalState();
  const { JWT, setJWT } = useGlobalState();
  const [loadingMain, setLoadingMain] = useState(false);
  const [isMapOpen, setIsMApOpen] = useState(false);
  const [mapUrl, setMapUrl] = useState('');
  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();
  const [sectors, setSectors] = useState<SectorItem[]>([]);

  type SectorAccess = {
    idAcceso: number;
  }

  type SectorItem = {
    idSector: number;
    sector: number;
    lat: number;
    lon: number;
    accesses: [];
  };
  const handleMapBtn = (item: SectorItem) => {

    const url = `https://maps.googleapis.com/maps/api/staticmap?center=${item.lat},${item.lon}&zoom=13&size=800x400&markers=color:green%7Clabel:A%7C${item.lat},${item.lon}&key=AIzaSyArNTcY1e_oLKgply89Mx2NySzONuIsYYc`
    setMapUrl(url)
    setIsMApOpen(true)
  };
  const handleRefresh = async () => {
    try {

      setLoading(true);
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/sectors/list',
          'JWT': JWT,

        },
        body: JSON.stringify({
          accesses: true,
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      storeAdmin(data);

    } catch (error) {
      console.error('Error fetching sectors:', error);
    } finally {

      setLoading(false);
    }
  };


  useEffect(() => {
    handleRefresh();
  }, []);

  return (
    <CustomAppLayout
      toolsHide={true}
      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: 'Inicio', href: '#home' },
            { text: 'Configuración', href: '#config/default' },
            { text: 'Sectores', href: '#create-transcription-job' },
          ]}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
        
        </>
      }
    />
  );
};
